export default class StateError extends Error {}
